/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_TitleInputs */

const en_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Script Generator`)
};

const de_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhandlungsskript-Generator`)
};

const fr_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de script de négociation`)
};

const es_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de guión de negociación`)
};

const it_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di script di negoziazione`)
};

const nl_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderhandelingsscriptgenerator`)
};

const pl_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generator skryptu negocjacyjnego`)
};

const fi_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuvotteluskriptin luonti`)
};

const da_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forhandlingsscriptgenerator`)
};

const sv_salary_negotiate_title = /** @type {(inputs: Salary_Negotiate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förhandlingsmansgenerator`)
};

/**
* | output |
* | --- |
* | "Negotiation Script Generator" |
*
* @param {Salary_Negotiate_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_title = /** @type {((inputs?: Salary_Negotiate_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_title(inputs)
	if (locale === "fr") return fr_salary_negotiate_title(inputs)
	if (locale === "es") return es_salary_negotiate_title(inputs)
	if (locale === "it") return it_salary_negotiate_title(inputs)
	if (locale === "nl") return nl_salary_negotiate_title(inputs)
	if (locale === "pl") return pl_salary_negotiate_title(inputs)
	if (locale === "fi") return fi_salary_negotiate_title(inputs)
	if (locale === "da") return da_salary_negotiate_title(inputs)
	if (locale === "sv") return sv_salary_negotiate_title(inputs)
	return en_salary_negotiate_title(inputs)
});